import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from "../components/ui/button";
import { Link } from 'react-router-dom';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-[#1a4a1a]/20 last:border-none">
      <button
        className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-[#1a4a1a]/5 transition-colors rounded-lg"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#1a4a1a]">{question}</h3>
        <span className={`text-2xl text-[#1a4a1a] transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}>
          +
        </span>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="px-6 pb-5 text-slate-600 leading-relaxed space-y-3">
              {Array.isArray(answer) ? (
                answer.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))
              ) : (
                <p>{answer}</p>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Is HalalCred a bank? Is it a direct lender?",
      answer: [
        "No, HalalCred is one of the first financing platforms focused on small businesses and non-profits. We partner with over five halal lenders and capital providers to help these organizations borrow and grow with confidence. However, HalalCred does not issue loans directly."
      ]
    },
    {
      question: "Are HalalCred loans halal & legitimate?",
      answer: [
        "Yes, all loans are halal and legitimate. While HalalCred is not a bank or a loan-granting company, we exclusively partner with trusted halal loan providers who follow a proper Shariah certification process. Our operations are guided by esteemed Shariah scholars, led by Mufti Ibrahim Essa, a faculty member at Darul Ifta, Jamiah Darul Uloom, Karachi, Pakistan.",
      ]
    },
    {
      question: "Who can use HalalCred's services?",
      answer: [
        "HalalCred's services are open to everyone, regardless of faith or background. We serve:",
        "• Small businesses seeking ethical financing",
        "• Nonprofits and community organizations",
        "• Communities underserved by traditional banks",
        "Our focus is on providing ethical, interest-free financial solutions while promoting economic development and social justice."
      ]
    },
    {
      question: "How does Islamic financing differ from conventional banking?",
      answer: [
        "Islamic financing differs from conventional banking in several key ways:",
        "• Prohibition of interest (riba)",
        "• Risk-sharing between financial institution and client",
        "• Asset-backed financing",
        "• Ethical investment screening",
        "• Focus on social benefit alongside profit",
        "All financial products must comply with Shariah principles and promote fair, ethical business practices."
      ]
    },
    {
      question: "What is a CDFI?",
      answer: [
        "A CDFI (Community Development Financial Institution) is a specialized financial institution that provides credit, financial services, and development services to underserved communities and markets.",
        "CDFIs are certified by the U.S. Department of the Treasury and play a crucial role in generating economic growth and opportunity in communities that lack access to traditional financial services."
      ]
    },
    {
      question: "What do CDFIs do?",
      answer: [
        "CDFIs serve communities that have been historically underserved by traditional financial institutions by:",
        "• Providing affordable lending for small businesses, nonprofits, and individuals",
        "• Offering financial education and technical assistance",
        "• Supporting community development projects",
        "• Creating jobs and economic opportunities",
        "• Facilitating affordable housing development",
        "• Building individual and community wealth through ethical financial practices"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-4xl mx-auto px-4 py-16 md:py-24">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1a4a1a] mb-6">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Learn more about CDFIs, Islamic financing, and how HalalCred is working to provide ethical financial solutions for our communities.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-[#1a4a1a]/20">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-slate-600 mb-8">
            Still have questions? Our team is here to help you.
          </p>
          <Link to="/consult">
            <Button 
              className="w-full md:w-auto bg-[#1a4a1a] hover:bg-[#1a4a1a]/90 text-white text-lg font-semibold px-12 py-6 rounded-[28px] shadow-lg transition-all duration-300"
              size="lg"
            >
              Send Message
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQs; 